import React from "react";
import { theme } from "../../Common/Credentials.js"

const Button = ({ children, onClick, disabled, className, variant = "primary", primaryColor = "#4d4d4d", size = "medium", type = "button", icon, startIcon, endIcon, loading, ...props }) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={`tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium tw-transition-all tw-duration-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 ${getVariantStyles(variant)} ${getSizeStyles(size)} ${className} ${disabled ? "tw-opacity-50 tw-cursor-not-allowed" : ""} ${loading ? "tw-cursor-wait" : ""}`}
            {...props}
        >
            {startIcon && <span className="tw-flex-shrink-0">{startIcon}</span>}
            {loading ? (
                <div className="tw-flex tw-items-center tw-gap-2">
                    <div className="tw-animate-spin tw-rounded-full tw-h-4 tw-w-4 tw-border-b-2 tw-border-current"></div>
                    <span>{children || "Loading"}</span>
                </div>
            ) : (
                <>
                    {children}
                    {endIcon && <span className="tw-flex-shrink-0">{endIcon}</span>}
                    {icon && !startIcon && !endIcon && <span className="tw-flex-shrink-0">{icon}</span>}
                </>
            )}
        </button>
    );
};

const getVariantStyles = (variant) => {
    switch (variant) {
        case "primary":
            return theme === "classic" ? `tw-bg-[#4d4d4d] tw-text-white tw-hover:bg-blue-700 tw-focus:ring-blue-500 tw-shadow-sm tw-hover:shadow-md` : "tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white tw-shadow-md tw-shadow-blue-600/10";
        case "primary-outline-hover":
            return theme === "classic" ? "tw-bg-white tw-border tw-border-[#4d4d4d] tw-text-[#4d4d4d] hover:tw-bg-[#4d4d4d] hover:tw-text-white hover:tw-border-transparent tw-transition-all tw-duration-300" : "tw-bg-white tw-border tw-border-blue-200 tw-text-blue-600 hover:tw-bg-gradient-to-r hover:tw-from-blue-600 hover:tw-to-indigo-600 hover:tw-border-transparent hover:tw-text-white tw-transition-all tw-duration-300"
        case "primary-outline":
            return theme === "classic" ? "tw-bg-white tw-border tw-border-[#4d4d4d] tw-text-[#4d4d4d]" : "tw-bg-white tw-border tw-border-blue-200 tw-text-blue-600"
        case "secondary":
            return "tw-bg-gray-200 tw-text-gray-800 tw-hover:bg-gray-300 tw-focus:ring-gray-400 tw-shadow-sm";
        case "outline":
            return "tw-bg-transparent tw-text-blue-600 tw-border tw-border-blue-600 tw-hover:bg-blue-50 tw-focus:ring-blue-500";
        case "danger":
            return "tw-bg-red-600 tw-text-white tw-hover:bg-red-700 tw-focus:ring-red-500 tw-shadow-sm tw-hover:shadow-md";
        case "success":
            return "tw-bg-green-600 tw-text-white tw-hover:bg-green-700 tw-focus:ring-green-500 tw-shadow-sm tw-hover:shadow-md";
        case "warning":
            return "tw-bg-yellow-500 tw-text-white tw-hover:bg-yellow-600 tw-focus:ring-yellow-500 tw-shadow-sm tw-hover:shadow-md";
        case "ghost":
            return "tw-bg-transparent tw-text-gray-700 tw-hover:bg-gray-100 tw-focus:ring-gray-400";
        default:
            return "tw-bg-blue-600 tw-text-white tw-hover:bg-blue-700 tw-focus:ring-blue-500 tw-shadow-sm tw-hover:shadow-md";
    }
};

const getSizeStyles = (size) => {
    switch (size) {
        case "small":
            return "tw-text-sm tw-px-3 tw-py-1.5";
        case "large":
            return "tw-px-6 tw-py-3 tw-text-base";
        case "xlarge":
            return "tw-px-8 tw-py-4 tw-text-lg";
        default:
            return "tw-text-sm tw-px-4 tw-py-2";
    }
};

export default Button;